<script>
    import { navigate } from 'svelte-routing';

    function goToPartidas() {
        navigate('/partida');
    }

    function goToClassificacao() {
        navigate('/classificacao');
    }
</script>

<nav class="navbar">
    <div class="navbar-brand">
        Torneio de Dominó da PRM
    </div>
    <div class="navbar-links">
        <button on:click={goToPartidas}>Partidas</button>
        <button on:click={goToClassificacao}>Classificação</button>
    </div>
</nav>

<style>
    .navbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 2rem;
        background-color: #333;
        color: rgb(118, 36, 36);
    }

    .navbar-brand {
        font-size: 1.5rem;
        font-weight: bold;
        color:white;
    }

    .navbar-links button {
        background-color: transparent;
        color: white;
        border: none;
        font-size: 1rem;
        margin-left: 1rem;
        cursor: pointer;
        transition: color 0.3s ease;
    }

    .navbar-links button:hover {
        color: #66cc66; /* Verde claro no hover */
    }

    .navbar-links button:focus {
        outline: none;
    }

    @media (max-width: 768px) {
        .navbar {
            flex-direction: column;
            align-items: flex-start;
        }

        .navbar-links {
            margin-top: 10px;
        }

        .navbar-links button {
            margin: 5px 0;
        }
    }
</style>
